import { render, staticRenderFns } from "./PriceRecordsDialog.vue?vue&type=template&id=0dfb55e6&scoped=true"
import script from "./PriceRecordsDialog.vue?vue&type=script&lang=js"
export * from "./PriceRecordsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb55e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfb55e6')) {
      api.createRecord('0dfb55e6', component.options)
    } else {
      api.reload('0dfb55e6', component.options)
    }
    module.hot.accept("./PriceRecordsDialog.vue?vue&type=template&id=0dfb55e6&scoped=true", function () {
      api.rerender('0dfb55e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sj_stopCarCard/components/PriceRecordsDialog.vue"
export default component.exports